import React, { Component } from "react";

class UploadDiv extends Component {
  state = {};
  render() {
    const width_upload = this.props.percent_upload * 100 + "%";
    const style = { width: width_upload };
    if (this.props.percent_upload === 1) {
      return <div />;
    }
    return (
      <label className="upload-loader">
        <div className="upload-loader-done" style={style} />
      </label>
    );
  }
}

export default UploadDiv;



// WEBPACK FOOTER //
// ./src/components/upload.jsx